const searchMenuByLabel = (menus, searchTerm) => {
  const term = searchTerm.toLowerCase();
  const result = [];
  menus.forEach(menu => {
    const match = menu.title.toLowerCase().includes(term);
    const matchingChildren = menu.children ? searchMenuByLabel(menu.children, searchTerm) : [];
    if (match || matchingChildren.length > 0) {
      result.push({
        ...menu,
        children: matchingChildren
      });
    }
  });
  return result;
};

export { searchMenuByLabel };
